import PropTypes from 'prop-types';
import React from 'react';

import CheckOption from './CheckOption';
import Section from './Section';

// Multi-select facet backed by a {label -> count} option list.
const CheckboxFacet = ({ title, options, selected, onToggle, onClear }) => (
  <Section title={title} badge={selected.length}>
    <div className="ab-opts">
      {options.map(({ label, count }) => (
        <CheckOption
          key={label}
          label={label}
          count={count}
          on={selected.includes(label)}
          onClick={() => onToggle(label)}
        />
      ))}
      {options.length === 0 && <div className="ab-empty">No matches</div>}
      {selected.length > 0 && (
        <button type="button" className="ab-clear" onClick={onClear}>Clear</button>
      )}
    </div>
  </Section>
);
CheckboxFacet.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default CheckboxFacet;
